import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/mode',
    name: 'Mode',
    component: () => import(/* webpackChunkName: "about" */ '../views/Mode.vue'),
  },
  {
    path: '/mode/presets',
    name: 'Presets',
    component: () => import(/* webpackChunkName: "about" */ '../views/Presets.vue'),
  },
  {
    path: '/mode/advanced',
    name: 'Advanced',
    component: () => import(/* webpackChunkName: "about" */ '../views/Advanced.vue'),
  },
  
  // {
  //   path: '/start',
  //   name: 'Dashboard',
  //   component: Home,
  //   children: [
  //     {
  //       path: 'orders',
  //       name: 'Orders',
  //       component: () => import(/* webpackChunkName: "about" */ '../views/Home.vue')
  //     },
  //   ]
  // }
  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 };
  }
})

export default router
